



















































import Vue from 'vue'
import Editor from '@tinymce/tinymce-vue'
import { CommentService } from '@/services/'
import BaseIcon from '../svgicons/BaseIcon.vue'
import CommentBlock from '@/components/comments/CommentBlock.vue'
import { editorConfig } from '@/helper/constants'
import { COMMENT_MAX_LENGTH } from '@/helper/constants'
import UISpinner from '../common/UISpinner.vue'

export default Vue.extend({
  data() {
    return {
      contentText: "",
      comments: [],
      offset: 0,
      limit: 5,
      showViewMore: true,
      posting: false
    }
  },
  components: {
    editor: Editor,
    BaseIcon,
    CommentBlock,
    UISpinner
  },
  props: {
    postId: {
      type: String,
      required: true
    },
    productId: {
      type: String,
      required: true
    },
    instructor: {
      type: Object
    },
    commentPermission: {
      type: String,
      default: ''
    },
    pendoPayload: {
      type: Object
    }
  },
  async mounted() {
    await this.findComments()
  },
  created() {
    this.$bus.$on("updateComment", this.updateComment)
    this.$bus.$on("deleteStateParentComment", this.deleteStateParentComment)
    this.$bus.$on("addNewReplyToState", this.addNewReplyToState)
    this.$bus.$on("deleteStateChildComment", this.deleteStateChildComment)
  },
  beforeDestroy() {
    this.$bus.$off("updateComment")
    this.$bus.$off("deleteStateParentComment")
    this.$bus.$off("addNewReplyToState")
    this.$bus.$off("deleteStateChildComment")
  },
  methods: {
    addNewReplyToState(params) {
      const parentCommentIndex = this.findCommentIndexById(params.parentCommentId)
      if (parentCommentIndex > -1) {
        this.comments[parentCommentIndex].replies.push(params)
      }
    },
    deleteStateParentComment(params) {
      const indexOfChild = this.findCommentIndexById(params.id)
      if (indexOfChild > -1) {
        this.comments = this.comments.filter(elem => elem.id !== params.id)
      }
    },
    findCommentIndexById(id: string) {
      return this.comments.findIndex(elem => String(elem.id) === String(id))
    },
    async createComment() {
      try {
        this.posting = true
        const { data: createdComment} = await CommentService.createComment({
          postId: this.postId,
          productId: this.productId,
          content: this.contentText,
          pendoPayload: {
            postTitle: this.pendoPayload.post.title,
            productTitle: this.pendoPayload.product.title,
            categoryTitle: this.pendoPayload.category.title 
          }
        })
        if (createdComment.error === false) {
          this.comments.push({ ...createdComment.comment, replies: [], isNonDb: true })
        }
        this.contentText = ""
        this.posting = false
      } catch (error) {
        console.error("Something went wrong", error)
      }
    },
    async updateComment(params: any) {
      try {
        await CommentService.updateComment(params.id, {
          content: params.content,
          pendoPayload: {
            postTitle: this.pendoPayload.post.title,
            productTitle: this.pendoPayload.product.title,
            categoryTitle: this.pendoPayload.category.title 
          }
        })
      } catch (error) {
        console.error("Something went wrong", error)
      }
    },
    deleteStateChildComment(params) {
      const parentCommentIndex = this.findCommentIndexById(params.parentCommentId)
      if (parentCommentIndex > -1) {
        this.comments[parentCommentIndex].replies = this.comments[parentCommentIndex].replies.filter(elem => elem.id !== params.id)
      }
    },
    async findComments() {
      try {
        const { data: commentslist } = await CommentService.findComments({
          postId: this.postId,
          productId: this.productId,
          offset: this.offset,
          limit: this.limit
        })

        if (commentslist.comments.length < this.limit) {
          this.showViewMore = false
        }

        this.offset = this.offset + this.limit

        let nondbComments = this.comments.filter(elem => elem.isNonDb === true)

        if (nondbComments.length === 0) {
          this.comments.push(...commentslist.comments)
        } else {
          const commentsToPushInList = []
          for (const index in commentslist.comments) {
            const comment = commentslist.comments[index]
            const foundNonDbComment = nondbComments.find(elem => elem.id === comment.id)
            if (foundNonDbComment === undefined) {
              commentsToPushInList.push(comment)
            } else {
              nondbComments = foundNonDbComment.filter(elem => elem.id !== comment.id)
            }
          }
          this.comments.push(...commentsToPushInList)
        }
        this.comments = this.comments.sort((a,b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
      } catch (error) {
        console.error("Something went wrong", error)
      }
    }
  },

  computed: {
    commentCharacterLength() {
      return COMMENT_MAX_LENGTH || 140
    },
    postButtonDisabled() {
      return this.replyTextLength > this.commentCharacterLength  || this.replyTextLength === 0
    },
    replyTextLength() {
      return this.contentText.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, ' ').length
    },
    editorConfig() {
      return editorConfig
    }
  }
})
